function changeStateButton() {
    let value = $(this).val();
    let btn = $(this).parents('.js-link-edit-in-modal-wrapper').find('.js-link-edit-in-modal');
    btn.attr('disabled', !value);
}


$('.js-link-edit-in-modal-wrapper .chosen-select').each(changeStateButton);
$(document).on('change', '.js-link-edit-in-modal-wrapper .chosen-select', changeStateButton);
$(document).on('chosen:updated', '.js-link-edit-in-modal-wrapper .chosen-select', changeStateButton);

function setFormInModal(url){
    let modal = $('#edit-in-iframe-modal');

    modal.find('.modal-body').html('<iframe class="w-100" src="'+url+'" sandbox="allow-same-origin allow-forms allow-scripts"\n' +
        '        onload="this.style.height=(this.contentWindow.document.body.scrollHeight+20)+\'px\';">\n' +
        '</iframe>');

    modal.modal('show');
}

$(document).on('click', '.js-link-edit-manufacturer-in-modal', function () {
    let select = $(this).parents('.js-link-edit-in-modal-wrapper').find('.chosen-select');
    let id = select.val().trim();

    setFormInModal(`/manufacturers/${id}/edit`);
});

$(document).on('click', '.js-link-edit-model-in-modal', function () {
    let select = $(this).parents('.js-link-edit-in-modal-wrapper').find('.chosen-select');
    let manufacturerSelect = $(this).parents('.js-link-edit-in-modal-wrapper').parent()
        .find('.js-link-edit-manufacturer-in-modal').parents('.js-link-edit-in-modal-wrapper').find('.chosen-select');
    let id = select.val().trim();
    let manufacturerId = manufacturerSelect.val().trim();

    console.log(manufacturerSelect, select)

    setFormInModal(`/manufacturers/${manufacturerId}/models/${id}/edit`);
});

$('body').append('<div class="modal fade" id="edit-in-iframe-modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">\n' +
    '    <div class="modal-dialog modal-dialog-centered modal-xl">\n' +
    '        <div class="modal-content">\n' +
    '            <div class="modal-body"></div>\n' +
    '            <div class="modal-footer">\n' +
    '                <button type="button" class="btn btn-secondary" data-dismiss="modal">Закрыть</button>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>');
